import React from 'react';
import { Typography } from '@banhala/ui-kit';

type ReviewContentProps = {
  contents: string;
};

export const ReviewContent: React.FC<ReviewContentProps> = ({ contents }) => {
  return (
    <Typography type={'subtitle2'} color={'content_primary'} numberOfLines={3}>
      {contents}
    </Typography>
  );
};
